window['Theme_ProductTileHover'] = (element) => ({
  productTitle: '',
  initialSwatch: null,
  isTouchDevice: false,
  lockedImageHeight: null,
  lockedImageWidth: null,
  init() {
    const titleNode = this.$root.querySelector('.font-heading');
    this.productTitle = titleNode ? titleNode.textContent.trim() : '';
    this.isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;

    const swatches = this.swatches;
    this.initialSwatch = swatches.find((swatch) => swatch.dataset.active === 'true') || swatches[0] || null;

    if (this.image) {
      const rect = this.image.getBoundingClientRect();
      if (rect.width && rect.height) {
        this.lockedImageWidth = Math.round(rect.width);
        this.lockedImageHeight = Math.round(rect.height);
        this.image.style.width = `${this.lockedImageWidth}px`;
        this.image.style.height = `${this.lockedImageHeight}px`;
      }
    }

    swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => {
        this.previewSwatch(swatch, { persist: true });
      });
      swatch.addEventListener('mouseover', () => {
        this.previewSwatch(swatch, { persist: true });
      });
      swatch.addEventListener('focus', () => {
        this.previewSwatch(swatch, { persist: true });
      });
      swatch.addEventListener('touchstart', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.previewSwatch(swatch, { persist: true, makeInitial: true });
      }, { passive: false });
      swatch.addEventListener('touchend', (event) => {
        event.preventDefault();
        event.stopPropagation();
      }, { passive: false });
      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.previewSwatch(swatch, { persist: true, makeInitial: true });
        if (!this.isTouchDevice && swatch.dataset.variantUrl) {
          window.location.href = swatch.dataset.variantUrl;
        }
      });
    });

    this.$root.addEventListener('mouseleave', () => {
      this.clearPreview();
    });

    if (this.initialSwatch) {
      this.applyVisualState(this.initialSwatch);
      this.setActiveSwatch(this.initialSwatch);
    }
  },
  get image() {
    return this.$root.querySelector('[data-product-tile-image]');
  },
  get hoverImage() {
    return this.$root.querySelector('[data-product-tile-hover-image]');
  },
  get hoverImageContainer() {
    return this.hoverImage ? this.hoverImage.parentElement : null;
  },
  get swatches() {
    return Array.from(this.$root.querySelectorAll('[data-product-tile-swatch]'));
  },
  get tileLink() {
    return this.$root.querySelector('[data-product-tile-link]');
  },
  setActiveSwatch(button) {
    this.swatches.forEach((swatch) => {
      swatch.dataset.active = swatch === button ? 'true' : 'false';
      swatch.style.border = swatch === button ? '1px solid currentColor' : '0';
    });

    if (this.tileLink && button?.dataset.variantUrl) {
      this.tileLink.setAttribute('href', button.dataset.variantUrl);
    }
  },
  applyVisualState(button) {
    if (!button) return;

    if (this.image && button.dataset.variantImage) {
      this.image.setAttribute('src', button.dataset.variantImage);
      this.image.setAttribute('alt', button.dataset.variantAlt || this.productTitle || '');
      if (this.lockedImageWidth && this.lockedImageHeight) {
        this.image.style.width = `${this.lockedImageWidth}px`;
        this.image.style.height = `${this.lockedImageHeight}px`;
      }
    }

    if (this.hoverImage && button.dataset.variantHoverImage) {
      this.hoverImage.setAttribute('src', button.dataset.variantHoverImage);
      this.hoverImage.setAttribute('alt', button.dataset.variantAlt || this.productTitle || '');
    }

  },
  previewSwatch(button, options = {}) {
    if (!button) return;
    this.applyVisualState(button);
    this.setActiveSwatch(button);
    if (options.makeInitial) {
      this.initialSwatch = button;
    }
  },
  clearPreview() {
    if (this.initialSwatch) {
      this.applyVisualState(this.initialSwatch);
      this.setActiveSwatch(this.initialSwatch);
    }

    if (this.hoverImageContainer) {
      this.hoverImageContainer.style.opacity = '';
    }
  },
});
